(() => {
  if (window.nekoanCollectionFiltersReady) return;
  window.nekoanCollectionFiltersReady = true;
  const desktop = matchMedia('(min-width: 1025px)');
  const selector = '.nekoan-collection-grid .page-sidebar--horizontal .js-filter:not(.refined-widgets)';
  const originals = new WeakMap();
  let serial = 0;
  const setOpen = (block, open, closed = false) => {
    block.toggleAttribute('data-nekoan-filter-open', open);
    block.toggleAttribute('data-nekoan-filter-closed', closed);
    block.querySelector('.sidebarBlock-heading')?.setAttribute('aria-expanded', String(open));
  };
  const prepare = () => {
    document.querySelectorAll(selector).forEach(block => {
      const heading = block.querySelector('.sidebarBlock-heading');
      const panel = block.querySelector('.facets__display');
      if (!heading || !panel) return;
      if (!originals.has(heading)) originals.set(heading, Object.fromEntries(['role', 'tabindex', 'aria-expanded', 'aria-controls'].map(name => [name, heading.getAttribute(name)])));
      if (desktop.matches) {
        if (!panel.id) panel.id = `nekoan-filter-panel-${++serial}`;
        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');
        heading.setAttribute('aria-controls', panel.id);
        heading.setAttribute('aria-expanded', String(block.hasAttribute('data-nekoan-filter-open')));
      } else {
        block.removeAttribute('data-nekoan-filter-open');
        block.removeAttribute('data-nekoan-filter-closed');
        Object.entries(originals.get(heading)).forEach(([name, value]) => value === null ? heading.removeAttribute(name) : heading.setAttribute(name, value));
      }
    });
  };
  document.addEventListener('keydown', event => {
    if (event.defaultPrevented) return;
    const heading = event.target.closest?.(`${selector} .sidebarBlock-heading`);
    const block = event.target.closest?.(selector);
    if (desktop.matches && block) {
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(block, false, true);
        block.querySelector('.sidebarBlock-heading')?.focus();
      } else if (heading && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        const open = !block.hasAttribute('data-nekoan-filter-open');
        document.querySelectorAll(selector).forEach(other => { if (other !== block) setOpen(other, false, true); });
        setOpen(block, open, !open);
      }
      return;
    }
    const mobileTrigger = event.target.closest?.('.nekoan-collection-grid [data-sidebar], .nekoan-collection-grid .label-tab[data-mobile="mobile"]');
    if (!desktop.matches && mobileTrigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      mobileTrigger.click();
    }
  });
  document.addEventListener('pointerover', event => {
    const block = event.target.closest?.(selector);
    if (!desktop.matches || !block || block.contains(event.relatedTarget)) return;
    setOpen(block, true);
  });
  document.addEventListener('pointerout', event => {
    const block = event.target.closest?.(selector);
    if (!desktop.matches || !block || block.contains(event.relatedTarget)) return;
    if (!block.contains(document.activeElement)) setOpen(block, false);
  });
  document.addEventListener('focusout', event => {
    const block = event.target.closest?.(selector);
    if (desktop.matches && block && !block.contains(event.relatedTarget) && !block.matches(':hover')) setOpen(block, false, true);
  });
  document.addEventListener('click', event => {
    if (!desktop.matches) return;
    document.querySelectorAll(selector).forEach(block => { if (!block.contains(event.target)) setOpen(block, false, true); });
  });
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; prepare(); });
  });
  document.querySelectorAll('.nekoan-collection-grid').forEach(grid => observer.observe(grid, {childList: true, subtree: true}));
  desktop.addEventListener('change', prepare);
  prepare();
})();
